import React from "react";
import { Switch, BrowserRouter as Router } from "react-router-dom";

import Route from "./lib/route";

import Index from "./pages/index";
import Contact from "./pages/contact";
import Auth from "./pages/auth";
import Rule from "./pages/rule";
import Privacy from "./pages/privacy";
import PageNotFound from "./pages/page-not-found";

export default () => {
  return (
    <Router>
      <Switch>
        <Route path="/" exact index component={Index} />
        <Route path="/contact" header exact component={Contact} footer />
        <Route path="/auth/" header component={Auth} footer />
        <Route path="/rule" header exact component={Rule} footer />
        <Route path="/privacy" header exact component={Privacy} footer/>
        <Route component={PageNotFound} footer />
      </Switch>
    </Router>
  );
};